/**
 * Standard single-line text cell for the data grids across the app.
 *
 * Renders a value clamped to one line with an ellipsis, a hover tooltip
 * carrying the full text, and an em-dash placeholder when the value is empty.
 * This is the house presentation for a plain string column — the same shape
 * the site-dashboard alarm cards and the alarm-history grid render — so every
 * grid shows blank/overflowing text the same way.
 *
 * Contains:
 * - GridTextCell — presentational one-line grid text cell (default export)
 */

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * @param {object} props
 * @param {string} [props.value] - the cell text; empty/nullish renders an em-dash.
 * @returns {JSX.Element}
 */
export default function GridTextCell({ value }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, height: '100%' }}>
      <Typography variant="body2" noWrap title={value || ''} sx={{ minWidth: 0 }}>
        {value || '—'}
      </Typography>
    </Box>
  );
}

GridTextCell.propTypes = {
  value: PropTypes.node,
};
